module.exports = __webpack_public_path__ + "static/media/logo.f908b59f.png";